
















import Vue from "vue"
export default Vue.extend({
  props: {
    hasBottomMarginForMobileNavBar: {
      type: Boolean,
      default: false,
    },
  },
})
